import React, { useState } from "react";
import { useNavigate } from "react-router";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner
} from "reactstrap";
import { logoutAPI } from "../../api/user";
import { Icon } from "../../components/Component";
import { useUserInfo } from "../../layout/provider/Theme";

const LogoutModal = ({ handelModal, modal }) => {
  const { setUserInfo } = useUserInfo();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const toggle = () => handelModal(!modal);
  const handleLogout = async () => {
    setLoading(true);
    try {
      const response = await logoutAPI();
      if (response) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("role");
        navigate("/login", { replace: true });
        setUserInfo(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader
          toggle={toggle}
          close={
            <button className="close" onClick={toggle}>
              <Icon name="cross" />
            </button>
          }
        >
          Logout
        </ModalHeader>
        <ModalBody>
          <p className=" fw-bold fs-16px">Are you sure you want to logout?</p>
          <div className=" w-100 d-flex justify-content-end">
            <Button color="white" onClick={toggle}>
              Cancel
            </Button>
            <Button color="danger" onClick={handleLogout} disabled={loading}>
              {loading ? <Spinner size={"sm"} /> : "Confirm"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default LogoutModal;
